export { default } from './confirm-record-delete'
